const normalizeAmount = (n) => {
  let fixedAmount = Math.trunc(n / 100);

  if(fixedAmount % 10 != 9) {
    fixedAmount = ((Math.round(fixedAmount / 10) * 10) - 1);
  }

  // console.log(n / 100, "=>", fixedAmount);

  return fixedAmount * 100;
}

const pfFormattedMoney = (amount) => {
  return theme.Currency.formatMoney(normalizeAmount(amount), theme.settings.moneyFormat).replace(/<[^>]*>/g, '').trim();
}

// Debounce utility
// FIX (13 Oct 2026): the pack items are read when the timer fires, not when the change event
// happens. The change event runs before onSelectChange() rebuilds the pack (setTimeout 0), so
// items read at event time still held the previous size's variant id - e.g. Double -> Single
// kept showing the Double price, Single -> King showed the (lower) Single price.
var variantChangeTimer = null;
function debouncedHandleVariantChange() {
  clearTimeout(variantChangeTimer);
  variantChangeTimer = setTimeout(function() {
    var activeTier = document.querySelector(".pf-bundle-item[data-active='true']");
    if (activeTier) handleVariantChange(pfActivePackItems(activeTier), activeTier);
  }, 300);
}

// Recalculates every tier from its own packs, so collapsed tiers never show a price for a
// different size/colour than the one their packs hold.
function pfRefreshAllTierPrices() {
  document.querySelectorAll("pf-bundle-selector .pf-bundle-item").forEach(function(tier) {
    handleVariantChange(pfActivePackItems(tier), tier);
  });
}

// FIX (23 Sep 2026): one line item per pack. Packs on two-option products (e.g. Size + Color on
// the slip set) have two selects that both hold the same combined variant id; reading every select
// double-counted each pack, and handleVariantChange() then crashed on the extra entries
// ("Cannot read properties of undefined (reading 'setAttribute')"), so the bundle price and the
// "lowest price" badge were never recalculated on those products.
//
// FIX (13 Oct 2026): each pack's variant is resolved from the option NAMES it shows (Size +
// Color), not from the variant id stored on one select. Those ids are only correct after
// rebuildPack() has run, so reading them can return the previous size's variant. The names are
// what the shopper sees and are always current. Falls back to the last select's value if no
// variant matches. Pass a tier to read that tier; defaults to the active one.
function pfActivePackItems(tier) {
  tier = tier || document.querySelector(".pf-bundle-item[data-active='true']");
  if (!tier) return [];

  var bundleEl = tier.closest("pf-bundle-selector");
  var variants = [];
  try { variants = JSON.parse((bundleEl && bundleEl.dataset.productVariants) || "[]"); } catch (err) {}

  return [...tier.querySelectorAll(".pf-bundle-pack")]
    .map(function(pack) {
      var selects = [...pack.querySelectorAll(".pf-bundle-variant select")];
      if (!selects.length) return null;

      var names = [];
      selects.forEach(function(select, k) {
        var wrap = select.closest(".pf-bundle-variant");
        var optIndex = wrap && wrap.hasAttribute("index") ? Number(wrap.getAttribute("index")) : k;
        var option = select.options[select.selectedIndex];
        names[optIndex] = option ? option.text.trim() : "";
      });

      var match = variants.find(function(v) {
        return v.options.every(function(o, i) { return o === names[i]; });
      });
      return { id: match ? String(match.id) : selects[selects.length - 1].value, quantity: 1 };
    })
    .filter(Boolean);
}

// FIX (23 Sep 2026): the theme deliberately leaves the add-to-cart button alone on bundle products
// (theme.js updateCartButton returns early when a pf-bundle-selector exists), so a sold-out colour
// or size (10 of the 12 slip colours) still showed "Add to cart" and failed with an error on click.
// The button now mirrors what will actually be added: the active tier's pack variants.
function pfSyncCartButton() {
  var bundleEl = document.querySelector("pf-bundle-selector");
  if (!bundleEl) return;
  var scope = bundleEl.closest('[data-section-type="product"]') || document;
  var btn = scope.querySelector("[data-add-to-cart]");
  var btnText = btn && btn.querySelector("[data-add-to-cart-text]");
  if (!btn || !btnText) return;

  // Same selects theme.AjaxProduct adds to the cart for a bundle.
  var selects = [...document.querySelectorAll(".pf-bundle-item[data-active='true'] .pf-bundle-variant.Color select")];
  if (!selects.length) return;

  var variants = [];
  try { variants = JSON.parse(bundleEl.dataset.productVariants || "[]"); } catch (err) {}
  var soldOut = selects.some(function(sl) {
    var v = variants.find(function(x) { return String(x.id) === String(sl.value); });
    return !v || !v.available;
  });

  btn.disabled = soldOut;
  btn.classList.toggle("disabled", soldOut);
  if (soldOut) {
    btnText.textContent = (window.theme && theme.strings && theme.strings.soldOut) || "Sold Out";
  } else if (btnText.dataset.defaultText) {
    btnText.textContent = btnText.dataset.defaultText;
  }
}

const getVariantPriceData = (variant, item) => {
  const data = {
    id: item.id,
    quantity: item.quantity,
    price: variant.price,
    priceFormatted: theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat),
    comparePrice: variant.compare_at_price || variant.price, // fallback to price if no compare
    comparePriceFormatted: theme.Currency.formatMoney(variant.compare_at_price || variant.price, theme.settings.moneyFormat),
    title: variant.title,
    available: variant.available
  };

  return data;
}

function getAllVariantPrices(variantsArray) {
  var requests = variantsArray.map(function(item) {
    const fetchUrl = '/variants/' + item.id + '.js';

    if (window.pfVariantPrices && window.pfVariantPrices[fetchUrl]) {
      return Promise.resolve(
        getVariantPriceData(window.pfVariantPrices[fetchUrl], item)
      );
    }

    return fetch(fetchUrl)
      .then(function(response) {
        return response.json();
      })
      .then(function(variant) {
        if (!window.pfVariantPrices) {
          window.pfVariantPrices = {};
        }

        window.pfVariantPrices[fetchUrl] = variant;

        return getVariantPriceData(variant, item);
      });
  });

  return Promise.all(requests);
}


// FIX (13 Oct 2026): prices one tier (default: the active one) and writes only to that tier, so a
// result can never land on a different tier than the packs it was calculated from. Each tier
// keeps a request counter; an older, slower calculation that finishes late is ignored.
var pfPriceRequestIds = new WeakMap();

function handleVariantChange(variants, tier) {
  tier = tier || document.querySelector(".pf-bundle-item[data-active='true']");
  if (!tier) return;
  if (!variants || !variants.length) return;
  // A pack showing a size/colour combination that doesn't exist has no variant id - nothing to price.
  if (variants.some(function(item) { return !item.id; })) return;

  var requestId = (pfPriceRequestIds.get(tier) || 0) + 1;
  pfPriceRequestIds.set(tier, requestId);

  getAllVariantPrices(variants).then(function(results) {
    if (pfPriceRequestIds.get(tier) !== requestId) return;

    var total = 0;
    var compareTotal = 0;
    var length = results.length / 2;
    var lowestPrice = results[0].price;
    const variantElements = tier.querySelectorAll(".pf-bundle-pack");

    results.forEach(function(variant, index) {
      var linePrice        = variant.price * variant.quantity;
      var compareLinePrice = variant.comparePrice * variant.quantity;
      total        += linePrice;
      compareTotal += compareLinePrice;
      console.log('Variant:', variant.title, '| Price:', variant.priceFormatted, '| Compare:', variant.comparePriceFormatted);

      if (variantElements[index]) variantElements[index].setAttribute("data-price", variant.price)

      if(variant.price < lowestPrice){
        lowestPrice = variant.price;
      }
    });

    if(results.length >= 4){
      console.log("jazbah", length)
      total = total - lowestPrice;
    }
    // compareTotal = compareTotal / length;

    variantElements.forEach(variant => {
      variant.classList.remove("lowest_price");
    });

    var lowestPack = Array.from(tier.querySelectorAll(`.pf-bundle-pack[data-price="${lowestPrice}"]`)).reverse()[0];
    if (lowestPack) lowestPack.classList.add("lowest_price");

    console.log("lowestPrice",lowestPrice)

    // Strip HTML span tags — get plain price text only
    var discountPriceEl  = tier.querySelector('.pf-bundle-prices .pf-price-discount .money');
    var originalPriceEl  = tier.querySelector('.pf-bundle-prices .pf-price-original .money');

    const discountAmount = Number(tier.dataset.discountAmount || 0) / 100;

    const discountValue = (total * discountAmount) || 0;

    var totalFormatted = pfFormattedMoney(total - discountValue);
    var compareTotalFormatted = pfFormattedMoney(compareTotal);

    console.log('Total:', totalFormatted);
    console.log('Compare Total:', compareTotalFormatted);

    if (discountPriceEl)  discountPriceEl.textContent  = totalFormatted;
    if (originalPriceEl)  originalPriceEl.textContent  = compareTotalFormatted;
  });
}

class PfBundleSelector extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.cachedVariants = {};

    const { signal } = this.#controller;
    this.variantImages = {};
    this.variants = JSON.parse(this.dataset.productVariants);

    this.dataset.variantImages?.split(",")?.forEach(vimg => {
      const [id, imgUrl] = vimg.trim().split(":");
      this.variantImages[id] = imgUrl;
    });

    this.bundleItems.forEach(bundleItem => {
      bundleItem.addEventListener("click", this.onBundleClick.bind(this), { signal });
    });

    this.bundleSelectEls.forEach(selectElm => {
      selectElm.addEventListener("change", this.onSelectChange.bind(this), { signal });
    });

    this.syncPrices();
    this.syncVariant();

    // PERF: removed the unconditional this.prefetchVariants() call that used to run here.
    // It looped over every variant on the product and eagerly fetched the ENTIRE product
    // page HTML for each one (/products/<handle>?variant=<id>&section_id=<id>) with no
    // throttling or visibility check — on a 21-30 variant product that meant 20-36 fetches
    // of ~800KB uncompressed HTML each, all firing in one burst on page load, well before
    // any shopper touched a bundle option. Since 23 Sep 2026 onSelectChange() rebuilds the
    // pack from the variant JSON already on the page (see rebuildPack), so no product HTML
    // is fetched at all. PERF-GUARD: do not re-add section/HTML fetches here.
    this.prefetchVariantsPrices();
    this.initializeBundleScript();

    document.addEventListener('change', function(e) {
      if (
        e.target.closest('.pf-bundle-item') &&
        e.target.classList.contains('pf-bundle-select')
      ) {
        // PERF/FIX: not just ".Size" - bundles on Color-only (or any other
        // single-option) products need their price recalculated too.
        debouncedHandleVariantChange();
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get activeBundleItem() {
    return this.querySelector(".pf-bundle-item[data-active='true']");
  }

  get bundleItems() {
    return Array.from(this.querySelectorAll(".pf-bundle-item"));
  }

  get bundleSelectEls() {
    return Array.from(this.querySelectorAll(".pf-bundle-select"));
  }

  get comparePriceEls() {
    return Array.from(document.querySelectorAll(".product__price.product__price--compare .money"));
  }

  get salePriceEls() {
    return Array.from(document.querySelectorAll(".product__price.on-sale .money"));
  }

  prefetchVariants() {
    // PERF: was JSON.parse(this.dataset.productJson) — the full escaped
    // product object (all variants/images/metafields), only ever used here
    // for .handle and .variants. .variants is already parsed above from the
    // separate, much smaller data-product-variants attribute; .handle now
    // comes from its own tiny data-product-handle attribute instead.
    const sectionId = this.dataset.sectionId;
    const productHandle = this.dataset.productHandle;

    if(!sectionId || !productHandle) return;

    this.variants?.forEach(async variant => {
      const variantId = variant.id;
      const fetchUrl = `/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;

      if(!this.cachedVariants[fetchUrl]) {
        const res = await fetch(fetchUrl);
        const html = await res.text();

        this.cachedVariants[fetchUrl] = html;
      }
    });
  }

  prefetchVariantsPrices() {
    if (!window.pfVariantPrices) window.pfVariantPrices = {};

    this.variants?.forEach(async variant => {
      const fetchUrl = '/variants/' + variant.id + '.js';

      if(!window.pfVariantPrices[fetchUrl]) {
        window.pfVariantPrices[fetchUrl] = variant;
      }
    })
  }

  syncPrices() {
    const comparePrice = this.activeBundleItem.querySelector(".pf-price-original");
    const salePrice = this.activeBundleItem.querySelector(".pf-price-discount");

    this.comparePriceEls?.forEach(el => {
      el.textContent = comparePrice.textContent;
    });

    this.salePriceEls?.forEach(el => {
      el.textContent = salePrice.textContent;
    });

    const priceElms = document.querySelectorAll(".pf-bundle-prices > p");

    priceElms.forEach(priceEl => {
      const moneyEl = priceEl.querySelector(".money");
      if(!moneyEl) return;

      const formatted = pfFormattedMoney(Number(priceEl.dataset.value));

      if(formatted != "Rs. 0") {
        moneyEl.textContent = formatted;
      }
    });
  }

  onBundleClick(e) {
    const el = e.currentTarget;
    if(!el || el.dataset.active == "true") return;

    if(this.activeBundleItem) this.activeBundleItem?.setAttribute("data-active", false);

    e.currentTarget?.setAttribute("data-active", true);
    this.syncPrices();
    pfSyncCartButton();

    // PERF: lazily build swatches / run variant checks the first time this
    // tier is opened, instead of doing it for every tier on page load.
    if (!this.initializedBundleTiers) this.initializedBundleTiers = new Set();

    if (!this.initializedBundleTiers.has(el)) {
      el.querySelectorAll('.pf-bundle-select').forEach(function (select) {
        try {
          buildColorSwatches(select.id);
        } catch (err) {
          console.error('buildColorSwatches failed for', select.id, err);
        }
      });

      el.querySelectorAll('.pf-bundle-pack').forEach(function (pack) {
        try {
          handlePackVariantChange(pack);
        } catch (err) {
          console.error('handlePackVariantChange failed', err);
        }
      });

      this.initializedBundleTiers.add(el);
    }

    // FIX (13 Oct 2026): syncPrices() above resets every tier to its server-rendered price,
    // which is for the page's initial variant - recalculate from what the packs actually hold.
    pfRefreshAllTierPrices();
  }

  // PERF: pack options are now rebuilt in the browser from the variant JSON that is
  // already on the page (data-product-variants). This used to fetch and parse the ENTIRE
  // product section (~450-700KB of HTML) on every pack colour/size change just to copy
  // one .pf-bundle-pack element back out of it. rebuildPack() reproduces exactly what
  // Liquid renders for ?variant=<id> (verified option-for-option against the server
  // output): for each option value, the variant that combines it with the other selected
  // options (value, disabled/available, data-price), plus the selected state.
  rebuildPack(packEl, variantId) {
    const variant = this.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return false;

    packEl.querySelectorAll(".pf-bundle-select").forEach((select, k) => {
      const wrap = select.closest(".pf-bundle-variant");
      const optIndex = wrap && wrap.hasAttribute("index") ? Number(wrap.getAttribute("index")) : k;

      Array.from(select.options).forEach(option => {
        const name = option.text.trim();
        const match = this.variants.find(v =>
          v.options.every((o, i) => (i === optIndex ? o === name : o === variant.options[i]))
        );
        const isSelected = name === variant.options[optIndex];

        option.value = match ? String(match.id) : "";
        option.disabled = !(match && match.available);
        option.selected = isSelected;
        option.defaultSelected = isSelected;
        option.setAttribute("data-price", match ? match.price : "");
      });
    });

    packEl.setAttribute("data-price", variant.price);
    return true;
  }

  onSelectChange(e) {
    const variantId = e.target.value;
    if (!variantId) return;

    const currentPackEl = e.target.closest(".pf-bundle-pack");
    if (!currentPackEl) return;

    // Runs after the snippet's own document-level "change" handler
    // (handlePackVariantChange), exactly like the old fetch-then-replace did,
    // so the final pack state is identical - just without the network round trip.
    setTimeout(() => {
      try {
        if (!this.rebuildPack(currentPackEl, variantId)) return;

        const packImgEl = currentPackEl.querySelector(".pf-pack-img");
        if (packImgEl && this.variantImages[variantId]) {
          const newImageEl = document.createElement("img");
          newImageEl.src = this.variantImages[variantId];
          packImgEl.replaceChildren(newImageEl);
        }

        currentPackEl.querySelectorAll(".pf-bundle-select").forEach(select => {
          buildColorSwatches(select.id);
        });
        pfSyncCartButton();
      } catch (err) {
        console.error("Variant update failed", err);
      }
    }, 0);
  }

  initializeBundleScript() {
    // PERF: only build swatches / run variant checks for the tier that is
    // actually visible on load (the other tiers are collapsed and hidden).
    // Hidden tiers are lazily initialized the first time the shopper opens
    // them - see onBundleClick() below. This avoids doing 3x-7x the DOM
    // work on every page load for tiers most visitors never expand.
    var activeItem = this.activeBundleItem;

    if (activeItem) {
      activeItem.querySelectorAll('.pf-bundle-select').forEach(function (select) {
        buildColorSwatches(select.id);
      });

      activeItem.querySelectorAll('.pf-bundle-pack').forEach(function (pack) {
        handlePackVariantChange(pack);
      });
    }

    this.initializedBundleTiers = new Set(activeItem ? [activeItem] : []);


    // Run once on load with initial select values.
    // PERF/FIX: not just ".Size" - bundles on Color-only (or any other
    // single-option) products need their price recalculated too.
    // FIX (13 Oct 2026): every tier, not just the open one - collapsed tiers showed prices for the
    // first available variant even when the URL / packs were a different size.
    pfRefreshAllTierPrices();
    pfSyncCartButton();
  }

  // FIX (23 Sep 2026): the packs now simply follow the variant the main Size/Colour picker
  // resolves to (theme "variantChange" event, see onMainVariantChange). The old syncVariant()
  // only copied the colour into the packs, then 500ms later reset every pack's size to the first
  // in-stock size, and on page load overwrote the pack size with the first size that had the
  // selected colour. Because the cart gets the PACK variants, a shopper who picked size M in the
  // main picker still had size S added to the cart, and a sold-out pick still showed "Add to cart".
  // Landing on a sold-out ?variant= is handled by the auto-select script in product-template.liquid.
  syncVariant() {
    const productSection = this.closest('[data-section-type="product"]');
    if (!productSection) return;
    productSection.addEventListener("variantChange", this.onMainVariantChange.bind(this), { signal: this.#controller.signal });
  }

  onMainVariantChange(e) {
    const variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;

    // Let any pack updates queued by the same click finish first, then mirror the main picker.
    clearTimeout(this.mainSyncTimer);
    this.mainSyncTimer = setTimeout(() => this.applyVariantToPacks(variant.id), 0);
  }

  applyVariantToPacks(variantId) {
    this.querySelectorAll(".pf-bundle-pack").forEach(pack => {
      if (!this.rebuildPack(pack, variantId)) return;

      const packImgEl = pack.querySelector(".pf-pack-img");
      if (packImgEl && this.variantImages[variantId]) {
        const newImageEl = document.createElement("img");
        newImageEl.src = this.variantImages[variantId];
        packImgEl.replaceChildren(newImageEl);
      }

      pack.querySelectorAll(".pf-bundle-select").forEach(select => {
        try {
          buildColorSwatches(select.id);
        } catch (err) {
          console.error("buildColorSwatches failed for", select.id, err);
        }
      });
    });

    pfRefreshAllTierPrices();
    pfSyncCartButton();
  }
}

if(!customElements.get("pf-bundle-selector")) {
  customElements.define("pf-bundle-selector", PfBundleSelector);
}

// Stamp the first available variant into the URL if no variant is present.
// FIX: this used to be a hard `window.location.replace()`, which reloads
// the whole page a split second after first paint - on the PDP that meant
// the correctly-priced bundle briefly appeared, then a second full page
// load re-rendered it (and, worse, any reload can pick up a stale/cached
// response, appearing to "revert" to the old price). Updating the URL via
// history.replaceState keeps the address bar in sync without a reload.
(function() {
  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  if (!urlVariantId) {
    const bundleEl = document.querySelector('pf-bundle-selector');
    if (!bundleEl) return;

    const allVariants = JSON.parse(bundleEl.dataset.productVariants || '[]');
    const firstAvailable = allVariants.find(v => v.available);

    if (firstAvailable) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', firstAvailable.id);
      window.history.replaceState(null, '', url.toString());
    }
  }
})();